import { Component, EventEmitter, HostBinding, HostListener, Input, OnInit, Output } from '@angular/core';
import { Color, ColorPickerControl } from '@iplab/ngx-color-picker';

@Component({
  selector: 'app-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.less'],
})
export class ColorPickerComponent implements OnInit {
  public colorControl = new ColorPickerControl();

  public isVisible: boolean = true;

  @Input()
  public set color(color: string) {
    this.colorControl.setValueFrom(color);
  }

  @Output()
  public colorChange: EventEmitter<string> = new EventEmitter();

  @HostBinding('style.background-color')
  public get background(): string {
    return this.colorControl.value.toHexString();
  }

  @HostListener('click', ['$event'])
  public showColorPicker(event: MouseEvent): any {
    if (this.isVisible === true) {
      return;
    }

    this.isVisible = !this.isVisible;
  }

  public overlayClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isVisible = false;
  }

  constructor() {}

  ngOnInit(): void {
    this.colorControl.valueChanges.subscribe((value: Color) => this.colorChange.emit(value.toHexString()));
  }
}
